export default __webpack_public_path__ + "images/b4006d7da4f9b94ef0c283b426124422.svg";